import { http } from '@/plugins/http';
import * as TYPES from './mutation-types';
import store from '@/store';
import axios from 'axios';

export const loadModels = ({ dispatch }, { brand }) => {
  dispatch('setFetching', { key: 'loadModels', value: true });
  dispatch('setModels', []);

  return http
    .get(`/service/models/?brand=${brand || ''}`)
    .then(data => {
      dispatch('setFetching', { key: 'loadModels', value: false });
      dispatch('setModels', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadModels', value: false });
      return Promise.reject(e);
    });
};

export const loadServices = ({ dispatch }, { brand }) => {
  dispatch('setFetching', { key: 'loadServices', value: true });
  dispatch('setServices', []);

  return http
    .get(`/service/services/?brand=${brand || ''}`)
    .then(data => {
      dispatch('setFetching', { key: 'loadServices', value: false });
      dispatch('setServices', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadServices', value: false });
      return Promise.reject(e);
    });
};

export const loadDealers = ({ dispatch }, { brand }) => {
  dispatch('setFetching', { key: 'loadDealers', value: true });
  dispatch('setDealers', []);

  return http
    .get(`/service/dealers/?brand=${brand || ''}`)
    .then(data => {
      dispatch('setFetching', { key: 'loadDealers', value: false });
      dispatch('setDealers', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadDealers', value: false });
      return Promise.reject(e);
    });
};

export const sendForm = (_, params) => {
  return http
    .post(`/service/send/`, params)
    .then(data => {
      let popupText = '';
      if (data.data.status === 'error') {
        popupText = 'Произошла ошибка.<br />Попробуйте повторить позднее.';
      } else {
        if (params.custom_success_message) {
          popupText =
            'Спасибо за обращение, пожалуйста, ожидайте подтверждения записи.';
        } else {
          popupText = 'Спасибо за вашу заявку';
        }
      }

      store.dispatch('Popups/addTitlePopup', popupText, { root: true });
      store.dispatch('Popups/togglePopup', 'popup-message', { root: true });
    })
    .catch(e => Promise.reject(e));
};

export const loadRecomendations = ({ dispatch }, params) => {
  dispatch('setFetching', { key: 'loadRecomendations', value: true });
  // return dispatch('setRecomendations', [
  //   {
  //     name: 'Sportage NQ5 № Н837ОО198 VIN XWEPV81FDN0002542',
  //     recommendations: [
  //       {
  //         description: 'Заменить вентилятор системы охлаждения ДВС',
  //       },
  //       {
  //         description: 'Заменить системы охлаждения ДВС',
  //       },
  //       {
  //         description: 'Заменить вентилятор охлаждения ДВС',
  //       },
  //       {
  //         description: 'Заменить вентилятор системы ДВС',
  //       },
  //       {
  //         description: 'Заменить вентилятор системы охлаждения',
  //       },
  //     ],
  //   },
  // {
  //   name: 'Test',
  //   recommendations: [
  //     {
  //       description: 'sssss',
  //     },
  //   ],
  // },
  // ]);
  const prep = new FormData();
  prep.append('telephone', params.telephone);
  return axios
    .post(`/api/terravtoapi/recommendations/`, prep)
    .then(data => {
      dispatch('setFetching', { key: 'loadRecomendations', value: false });
      dispatch('setRecomendations', data.data[0].cars);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadRecomendations', value: false });
      dispatch('setRecomendations', []);
    });
};

export const setBrands = ({ commit }, value) => commit(TYPES.SET_BRANDS, value);
export const setModels = ({ commit }, value) => commit(TYPES.SET_MODELS, value);
export const setServices = ({ commit }, value) =>
  commit(TYPES.SET_SERVICES, value);
export const setDealers = ({ commit }, value) =>
  commit(TYPES.SET_DEALERS, value);
export const setFetching = ({ commit }, value) =>
  commit(TYPES.SET_FETCHING, value);
export const setRecomendations = ({ commit }, value) =>
  commit(TYPES.SET_RECOMENDATIONS, value);
